module.exports = __webpack_public_path__ + "img/gift2.2f31d8af.png";